import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    role: 'gestionnaire'
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post('/auth/register', formData);
      toast.success('Inscription réussie! En attente d\'approbation par le Groupe.');
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de l\'inscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-4 py-8">
      <div className="w-full max-w-md">
        <div className="glass-panel p-8 animate-fadeIn">
          <div className="text-center mb-8">
            <img 
              src="/images/noodly-logo.png" 
              alt="Noodly" 
              className="h-16 mx-auto mb-4"
            />
            <h1 className="text-3xl font-bold mb-2 text-white" style={{fontFamily: 'Space Grotesk'}}>Rejoindre Noodly</h1>
            <p className="text-gray-400">Créez votre compte licencié</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="register-form">
            <div>
              <Label htmlFor="name" className="text-white">Nom complet</Label>
              <Input
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
                className="mt-2 bg-white/5 border-white/10 text-white"
                placeholder="Jean Dupont"
                data-testid="register-name-input"
              />
            </div>

            <div>
              <Label htmlFor="email" className="text-white">Email</Label>
              <Input
                id="email"
                type="text"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
                className="mt-2 bg-white/5 border-white/10 text-white"
                placeholder="jean@example.com"
                data-testid="register-email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-white">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                required
                minLength={6}
                className="mt-2 bg-white/5 border-white/10 text-white"
                placeholder="••••••••"
                data-testid="register-password-input"
              />
            </div>

            <div>
              <Label htmlFor="role" className="text-white">Type de compte</Label>
              <Select 
                value={formData.role} 
                onValueChange={(value) => setFormData({...formData, role: value})}
              >
                <SelectTrigger className="mt-2 bg-white/5 border-white/10 text-white" data-testid="register-role-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-zinc-900 border-white/10">
                  <SelectItem value="licencie" className="text-white">Licencié</SelectItem>
                  <SelectItem value="gestionnaire" className="text-white">Gestionnaire Noodly</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#d03367] hover:bg-[#e04579] text-white font-medium py-6"
              data-testid="register-submit-button"
            >
              {loading ? 'Inscription...' : 'S\'inscrire'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-400 text-sm">
              Déjà un compte ?{' '}
              <Link to="/login" className="text-[#d03367] hover:text-[#e04579] font-medium">
                Se connecter
              </Link>
            </p>
          </div>

          {/* Branding */}
          <div className="mt-8 text-center">
            <p className="text-gray-500 text-xs">
              Solution développée par <span className="text-white font-medium">BESSON SOLUTIONS</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
